<template>
  <input
    :value="shown"
    type="text"
    inputmode="decimal"
    autocomplete="off"
    @focus="onFocus"
    @blur="onBlur"
    @input="onInput($event.target.value)"
    @keydown.enter="$event.target.blur()"
  >
</template>

<script>
export default {
  name: 'TomaMoneyInput',
  props: { value: { type: [Number, String], default: null } },
  data () { return { focused: false, text: '', last: this.value } },
  computed: {
    shown () { return this.focused ? this.text : this.format(this.last) }
  },
  watch: {
    value (value) { if (!this.focused) this.last = value }
  },
  methods: {
    // Accepts "150000", "150.000", "150000.00", "1500,50" and "1.500,50".
    parse (raw) {
      const text = String(raw == null ? '' : raw).replace(/[^\d.,]/g, '')
      if (!text) return null
      const commas = (text.match(/,/g) || []).length
      const dots = (text.match(/\./g) || []).length
      let normalized
      if (commas && dots) {
        const decimal = Math.max(text.lastIndexOf(','), text.lastIndexOf('.'))
        normalized = text.slice(0, decimal).replace(/[.,]/g, '') + '.' + text.slice(decimal + 1).replace(/[.,]/g, '')
      } else if (commas > 1) {
        normalized = text.replace(/,/g, '')
      } else if (commas === 1) {
        normalized = text.replace(',', '.')
      } else if (dots > 1) {
        normalized = text.replace(/\./g, '')
      } else if (dots === 1 && text.split('.')[1].length === 3) {
        normalized = text.replace('.', '')
      } else {
        normalized = text
      }
      const value = Number(normalized)
      return Number.isFinite(value) ? value : null
    },
    number (value) {
      if (value == null || value === '') return null
      if (typeof value === 'number') return Number.isFinite(value) ? value : null
      return this.parse(value)
    },
    format (value) {
      const valueNumber = this.number(value)
      return valueNumber == null ? '' : '$ ' + valueNumber.toLocaleString('es-AR', { maximumFractionDigits: 2 })
    },
    plain (value) {
      const valueNumber = this.number(value)
      return valueNumber == null ? '' : String(valueNumber)
    },
    onFocus (event) {
      this.focused = true
      this.text = this.plain(this.last)
      const target = event && event.target
      if (target) {
        target.value = this.text
        if (target.select) target.select()
      }
    },
    onInput (raw) {
      this.text = String(raw == null ? '' : raw).replace(/[^\d.,]/g, '')
      const value = this.parse(this.text)
      if (value !== this.last) {
        this.last = value
        this.$emit('input', value)
      }
    },
    onBlur () {
      if (!this.focused) return
      const value = this.parse(this.text)
      this.focused = false
      this.text = ''
      if (value !== this.last) {
        this.last = value
        this.$emit('input', value)
      }
      this.$emit('blur')
    }
  }
}
</script>
